// export const API_URL = 'http://localhost:3030/api';
// export const API_URL = 'https://solidartist-api.vercel.app/api';
export const API_URL = 'https://pruebas-api.solidartist.org/api';
export const AVALANCHE_MAINNET_PARAMS = {
    chainId: "0xA86A",
    chainName: "Avalanche Mainnet C-Chain",
    nativeCurrency: {
        name: "Avalanche",
        symbol: "AVAX",
        decimals: 18,
    },
    rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
    blockExplorerUrls: ["https://snowtrace.io/"],
}


